var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2v7c0 .552-.448 1-1 1s-1-.448-1-1V0z",
    transform: "scale(-1 1) rotate(-45 3.234 11.506)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1c0 .552-.448 1-1 1H0V0h7c.552 0 1 .448 1 1z",
    transform: "scale(-1 1) rotate(-45 3.234 11.506)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron.a71a3dbc4aa9971e5f92ed8740f5b365.svg";